import $ from 'jquery';

export default class OP3MovingImage {
    /**
     * Initialize moving image.
     * Library will create scrolling effect when image is hovered
     * and it will scroll same speed no matter how hight image is.
     * 
     * @param {String} selector 
     * @return {Void}
     */
    constructor(selector) {
        let _this     = this;
        this.selector = selector;
        this.items    = [];

        $(selector).each((index, element) => {
            // Let's prepare all the elements
            let $container = $(element);
            let $img       = $container.find('img');
            let src        = $img.attr('src');
            let image      = new Image();

            // Check when the image is loaded
            if (src) {
                image.onload = function () {
                    $img.src = this.src;

                    // Calculate the height difference for the image slider
                    let heightDifference = parseInt($img.height() - $container.height());

                    if (heightDifference > 0) {
                        // Set the transform duration based on the image height 
                        $container.attr('data-transform-y', heightDifference);
                        $container.find('img').css('transition', `transform ${heightDifference / 200}s ease-in-out`);

                        // Add hover/out events to slide the image up/down
                        $container
                            .hover(
                                () => {
                                    $container.find('img').css('transform', `translateY(-${$container.attr('data-transform-y')}px)`);
                                },
                                () => {
                                    $container.find('img').css('transform', ``);
                                }
                            )
                        ;
                        _this.items.push($container);
                    }
                };

                // Set src to actual src to load
                image.src = src;
            }
        });
    }

    /**
     * Destroy moving image instance.
     * 
     * @return {Void}
     */
    destroy() {
        this.items.forEach(($image) => {
            $image.unbind();
        });

        this.items = [];
    }
}
